export default "__VITE_ASSET__LOYZiB0e__"